import { CaretLeft, CaretRight } from "@phosphor-icons/react";
import { useState, useEffect, useRef } from "react";

const ServiceCard = ({ projects = [], title = "Our Services" }) => {
  const colors = ["rgb(93, 95, 243)", "rgb(85, 175, 104)", "rgb(234, 90, 84)", "rgb(247, 207, 102)"];

  const [startIndex, setStartIndex] = useState(0);
  // const visibleCount = 3;
  const totalCards = projects.length;
  // const isScrollable = totalCards > visibleCount;

    const [visibleCount, setVisibleCount] = useState(3);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 640) {
                setVisibleCount(1);
            } else if (window.innerWidth < 1024) {
                setVisibleCount(2);
            } else {
                setVisibleCount(3);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    const isScrollable = projects.length > visibleCount;

  const prevSlide = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const nextSlide = () => {
    if (startIndex + visibleCount < totalCards) {
      setStartIndex(startIndex + 1);
    }
  };

  return (
    <div className="Project-network">
      <h2 className="text-center text-2xl font-bold mb-6">{title}</h2>

      <div className="w-full flex items-center justify-center">
        {isScrollable && (
          <button onClick={prevSlide} className="mr-4 partner-slide-button" disabled={startIndex === 0}>
            <CaretLeft size={20} />
          </button>
        )}

        <div className="w-full max-w-[830px] overflow-hidden">
          <div
            className="flex transition-transform duration-500 ease-in-out cards-section"
            style={{ transform: `translateX(-${startIndex * (100 / visibleCount)}%)` }}
          >
            {projects.map((project, index) => {
              const cardColor = colors[index % colors.length];
              const projectTitle = project?.title || "";
              const projectSubtitle = project?.sub_title || "";
              const projectImage = project?.image?.data?.attributes?.url || "";
              const imageAlt = project?.image?.data?.attributes?.alternativeText || "";
              const projectLink = project?.link?.url || "#";

              return (
                <div
                  key={project?.id || index}
                  className="home-project-card card-hover w-[260px] flex-shrink-0 mx-2 border rounded-lg p-4"
                >
                  <h6 className="service-card-head" style={{ backgroundColor: cardColor }}>
                    {projectTitle}
                  </h6>

                  {projectImage && <img src={projectImage} alt={imageAlt} className="image-project" />}

                  <div className="project-card-home">
                    <TruncatedText text={projectSubtitle} link={projectLink} />

                    {project?.link?.title ? (
                      <a
                        className="explore-button"
                        target="_blank"
                        rel="noopener noreferrer"
                        // style={{ "--hover-color": cardColor }}
                        href={projectLink}
                      >
                        <div className="explore-title">{project?.link?.title || ""}</div>
                      </a>
                    ) : (
                      <div className="mt-10"></div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {isScrollable && (
          <button onClick={nextSlide} className="ml-4 partner-slide-button" disabled={startIndex + visibleCount >= totalCards}>
            <CaretRight size={20} />
          </button>
        )}
      </div>
    </div>
  );
};

const TruncatedText = ({ text, link }) => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      setIsOverflowing(textRef.current.scrollHeight > textRef.current.clientHeight);
    }
  }, [text]);

  return (
    <>
      <p className="project-card-home-pg line-clamp-3" ref={textRef}>
        {text}
      </p>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        // className={`read-more-button ${isOverflowing ? "visible" : "invisible"}`}
        className="read-more-button"
        style={{ display: isOverflowing ? 'block' : 'none' }} 
      >
        read more
      </a>
    </>
  );
};

export default ServiceCard;
